var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
const Svg4Grey = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "91px",
    height: "75px",
    viewBox: "0 0 91 75",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group Copy 4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy-4",
    fill: "#242424",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.4,22.3 L6.5,5.6 L6.5,59.6 L35.4,68.3 L35.4,22.3 Z M38.5,22.4 L38.5,68.3 L67.6,59.5 L67.6,5.6 L38.5,22.4 Z M90.2,4.3 C90.2,2.4 88.7,0.9 86.8,0.9 C84.9,0.9 83.4,2.4 83.4,4.3 L83.4,8 L90.2,8 L90.2,4.3 Z M84.3,58.6 L83.4,58.6 L86.8,70.5 L90.2,58.6 L89.4,58.6 L90.2,58.6 L90.2,10.6 L83.4,10.6 L83.4,58.6 L84.3,58.6 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "73.8 8 70.7 5.5 70.7 61 38.6 71.4 35.4 71.4 3.4 62.5 3.4 5.5 0.3 8 0.3 64.6 35.2 74.3 38.8 74.3 70.9 64.1 73.8 63.2"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(Svg4Grey);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/4_grey.21d7ba835f58cc12d3fd5a7134d81c4f.svg";